type ExperimentParameters = Record<string, string>;
export type ExperimentDefinition = readonly [string, ExperimentParameters];
export type ExperimentDefinitions = Record<string, ExperimentDefinition>;

export const ExperimentLayers = {
  Measures: [
    "telehealth_measures",
    {
      ShouldShowClientMeasures: "shouldShowClientMeasures",
      ShouldShowProviderMeasures: "shouldShowProviderMeasures",
    },
  ],
} as const satisfies ExperimentDefinitions;
